import React from "react";
import styles from "./style.module.css";
import { images } from "../../../../assets/images";

const ImageCarousal = ({ img }) => {
  return (
    <div className={styles.imageContainer}>
      <div className={styles.image}>
        <img className={styles.img} src={img} alt="" />
      </div>
      <div className={styles.info}>
        <div className={styles.firstRow}>
          <div className={styles.name}>Member Name</div>
          <div className={styles.link}>
            <img
              className={styles.circleArrow}
              src={images.circleArrow}
              alt="circl_Arrow"
            />
          </div>
        </div>
        <div className={styles.lastRow}>Designation@company</div>
      </div>
    </div>
  );
};

export default ImageCarousal;
